import { userContext } from '../userManager';

export const apiInvestmentObjectivesGet = (id) =>
  userContext.apiCall({ url: `/investment-objectives/${id}` });

export const apiInvestmentObjectivesPatch = (
  id,
  {
    userId,
    initialInvestment,
    investmentPeriod,
    averageYearlyInvestment,
    title,
    typeId,
    targetAmount,
    retirementStartAge,
    retireeDateOfBirth,
    desiredMonthlyIncome,
  }
) => {
  const showDetails = retirementStartAge && retireeDateOfBirth && desiredMonthlyIncome;

  return userContext.apiCall({
    url: `/investment-objectives/${id}`,
    method: 'PATCH',
    body: {
      userId,
      initialInvestment,
      investmentPeriod,
      averageYearlyInvestment,
      title,
      typeId,
      targetAmount,
      details: showDetails
        ? {
            retirementStartAge: Number(retirementStartAge),
            retireeDateOfBirth: `${retireeDateOfBirth}-01-01`,
            desiredMonthlyIncome: Number(desiredMonthlyIncome),
          }
        : undefined,
    },
  });
};

export const apiInvestmentObjectiveGet = (id) =>
  userContext.apiCall({
    url: `/investment-objectives/${id}`,
  });

export const apiInvestmentObjectivePortfolioProposalsGet = (id) =>
  userContext.apiCall({
    url: `/investment-objectives/${id}/portfolio-proposals`,
  });

export const apiInvestmentObjectivePortfolioProposalsPost = (
  id,
  { type, name, parentProposalId, parentModelPortfolioId, published }
) =>
  userContext.apiCall({
    url: `/investment-objectives/${id}/portfolio-proposals`,
    method: 'POST',
    body: {
      type,
      name,
      parentProposalId,
      parentModelPortfolioId,
      published,
    },
  });

export const apiInvestmentObjectivesChangeRequest = (id, { message, desiredVar }) =>
  userContext.apiCall({
    url: `/investment-objectives/${id}/change-request`,
    method: 'POST',
    noResBody: true,
    body: {
      desiredVar,
      message,
    },
  });

export const apiInvestmentObjectivePortfolioProposalsMultiplePatch = (
  id,
  { portfolioProposals }
) => {
  return userContext.apiCall({
    url: `/investment-objectives/${id}/portfolio-proposals`,
    method: 'PATCH',
    body: { portfolioProposals },
  });
};

export const apiInvestmentObjectivePortfoliosGet = (id) =>
  userContext.apiCall({
    url: `/investment-objectives/${id}/portfolios`,
  });
